"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNftCommunityFromGroupingResponseToJSON = exports.GetNftCommunityFromGroupingResponseFromJSONTyped = exports.GetNftCommunityFromGroupingResponseFromJSON = void 0;
var _1 = require("./");
function GetNftCommunityFromGroupingResponseFromJSON(json) {
    return GetNftCommunityFromGroupingResponseFromJSONTyped(json, false);
}
exports.GetNftCommunityFromGroupingResponseFromJSON = GetNftCommunityFromGroupingResponseFromJSON;
function GetNftCommunityFromGroupingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'community': (0, _1.NftCommunityFromJSON)(json['community']),
    };
}
exports.GetNftCommunityFromGroupingResponseFromJSONTyped = GetNftCommunityFromGroupingResponseFromJSONTyped;
function GetNftCommunityFromGroupingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'community': (0, _1.NftCommunityToJSON)(value.community),
    };
}
exports.GetNftCommunityFromGroupingResponseToJSON = GetNftCommunityFromGroupingResponseToJSON;
